<template>
<section>
  <div class="support-instruction">

  <p>We value your feedback and are here to assist you with any questions or concerns regarding Unemployed Deadbeats and our apps. To ensure a secure and spam-free experience, we use a One-Time Password (OTP) verification process before allowing message submissions.</p>

  <p class="section-header">Why Do We Require OTP Verification?</p>

  <p>To prevent spam and unauthorized submissions, we require users to verify their email before sending feedback or support requests. This ensures that every request we receive is from a real user and allows us to respond appropriately.</p>

  <p class="section-header">How It Works</p>
  <p class="section-primary-point">Enter Your Email</p>
  <p>Provide a valid email address where we can send your verification code.</p>

  <p class="section-primary-point">Receive a One-Time Password (OTP)</p>
  <p>Check your inbox for a 6-digit verification code. If you don’t see it, check your spam/junk folder.</p>

  <p class="section-primary-point">Enter the Code & Submit Your Message</p>
  <p>Once verified, you can submit your support request or feedback.</p>

  <p class="section-primary-point">We’ll Review & Respond</p>
  <p>Our team will review your message and get back to you as soon as possible.</p>
<!--  <p class="section-header">&nbsp;</p>-->
<!--  <p>If you run into issues receiving your OTP, try resending the code or checking your spam folder.</p>-->

  Ready to start? Enter your email below!
  </div>
</section>

</template>

<script setup lang="ts">
</script>

<style scoped>
.support-instruction {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  text-align: left; /* ✅ Change from center to left */
  margin-bottom: 15px;
}

.support-instruction h2 {
  text-align: left; /* ✅ Ensures the heading is also aligned left */
}

.support-instruction ul {
  padding-left: 20px; /* ✅ Adds proper list indentation */
}
</style>